import React, { useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { getLiveStream } from "../../../store/social/social.selector";
import {
    Button,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@material-ui/core";
import { copyToClipboard, pad, IsNullOrEmpty } from "../../../helpers/utility";
import _ from "underscore";
import Swal from "sweetalert2";
import SocialAPI from "../../../store/social/social.api";
import {
    getSearchedUsers,
    getUserProfile,
} from "../../../store/user/user.selector";
import { getCategoryList } from "../../../store/shopping/shopping.selector";
import VIPCircleAPI from "../../../store/user/vipcircle/vipcircle.api";
import { useHMSActions } from "@100mslive/react-sdk";
import { FileCopy } from "@material-ui/icons";

const Schedule = () => {
    const hmsActions = useHMSActions();
    const [values, setValues] = useState({
        day: moment().add(30, "minutes").format("DD"),
        month: moment().add(30, "minutes").format("MM"),
        year: moment().add(30, "minutes").format("YYYY"),
        hour: moment().add(30, "minutes").format("hh"),
        minute: moment().add(30, "minutes").format("mm"),
        meridian: moment().add(30, "minutes").format("a"),
        timeZone: moment.tz.guess(),
    });
    const { livestream, categories, users, userProfile } = useSelector(
        (state) => {
            return {
                livestream: getLiveStream(state),
                users: getSearchedUsers(state),
                categories: getCategoryList(state),
                userProfile: getUserProfile(state),
            };
        }
    );

    const savePreviewStream = (sch) => {
        let data = {
            title: livestream.title,
            contents: livestream.contents,
            hashtags: livestream.hashtags,
            timeStart: moment(
                `${values.year}-${values.month}-${values.day} ${values.hour}:${values.minute}:${values.meridian}`,
                "YYYY-MM-DD hh:mm:a"
            )
                .tz(values.timeZone)
                .format(),
        };

        if (
            moment(data.timeStart).diff(
                moment().tz(values.timeZone),
                "minutes"
            ) < 25
        ) {
            Swal.fire({
                title: "Livestream",
                text: "Please schedule a livestream atleast 30 minutes from now",
                icon: "error",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                showConfirmButton: false,
                cancelButtonText: "Close",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
            });
        } else {
            let selectedCategory = _.find(
                categories,
                (x) => x._id === livestream.category
            );
            SocialAPI.UpdatePreviewLiveStream(livestream._id, data)
                .then(async () => {
                    let VIPEmails = [];
                    let VIPIds = [];
                    if (selectedCategory.name === "VIP Circle") {
                        let circle = await VIPCircleAPI.GetVIPCircle(
                            livestream.parent
                        );
                        VIPEmails = circle.data.guests
                            .filter((x) => x.status === "Subscribed")
                            .map((x) => x.userId);
                        const filterIds = _.filter(
                            users,
                            (x) => VIPEmails.indexOf(x._id) > -1
                        );
                        VIPEmails = filterIds.map((x) => x.email);
                        VIPIds = filterIds.map((x) => x._id);
                    }

                    [...livestream.emails, ...VIPEmails].map((ls) => {
                        let mail = ``;
                        if (selectedCategory.name === "Public Hall") {
                            mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                Scheduled public hall has been set
                </p>
                <p style="line-height: 30px; text-align:center">
                    Hello <span style="color:#8B22F9">${ls}</span>,<br />
                    <span style="color:#8B22F9">${
                        livestream.owner.fullName
                    }</span> has scheduled a public hall.<br/>
                    Here are the public hall details
                </p>
                <p style="text-align:center;background:#F1F1F1;">
                    <br />
                    <span style="color:#8B22F9">Public Hall</span>: ${
                        livestream.title
                    }<br />
                            <span style="color:#8B22F9">Description</span>: ${
                                livestream.contents
                            }<br />
                    <span style="color:#8B22F9">Date and Time</span>: ${moment(
                        data.timeStart
                    ).format("lll")}<br />
                    <br />
                </p>`;
                        } else if (selectedCategory.name === "Private Hall") {
                            mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                Scheduled private lounge has been set
                </p>
                <p style="line-height: 30px; text-align:center">
                    Hello <span style="color:#8B22F9">${ls}</span>,<br />
                    <span style="color:#8B22F9">${
                        livestream.owner.fullName
                    }</span> has scheduled a private lounge.<br/>
                    Here are the private lounge details
                </p>
                <p style="text-align:center;background:#F1F1F1;">
                    <br />
                    <span style="color:#8B22F9">Private Lounge</span>: ${
                        livestream.title
                    }<br />
                            <span style="color:#8B22F9">Description</span>: ${
                                livestream.contents
                            }<br />
                    <span style="color:#8B22F9">Date and Time</span>: ${moment(
                        data.timeStart
                    ).format("lll")}<br />
                    <br />
                </p>`;
                        } else if (selectedCategory.name === "Meeting Room") {
                            mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                Scheduled meeting has been set
                </p>
                <p style="line-height: 30px; text-align:center">
                    Hello <span style="color:#8B22F9">${ls}</span>,<br />
                    <span style="color:#8B22F9">${
                        livestream.owner.fullName
                    }</span> has scheduled a video meeting.<br/>
                    Here are the meeting room details
                </p>
                <p style="text-align:center;background:#F1F1F1;">
                    <br />
                    <span style="color:#8B22F9">Meeting Room</span>: ${
                        livestream.title
                    }<br />
                            <span style="color:#8B22F9">Description</span>: ${
                                livestream.contents
                            }<br />
                    <span style="color:#8B22F9">Date and Time</span>: ${moment(
                        data.timeStart
                    ).format("lll")}<br />
                    <br />
                </p>`;
                        } else if (selectedCategory.name === "VIP Circle") {
                            mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                Scheduled VIP circle has been set
                </p>
                <p style="line-height: 30px; text-align:center">
                    Hello <span style="color:#8B22F9">${ls}</span>,<br />
                    <span style="color:#8B22F9">${
                        livestream.owner.fullName
                    }</span> has scheduled a VIP Circle.<br/>
                    Here are the VIP Circle details
                </p>
                <p style="text-align:center;background:#F1F1F1;">
                    <br />
                    <span style="color:#8B22F9">VIP Circle</span>: ${
                        livestream.title
                    }<br />
                            <span style="color:#8B22F9">Description</span>: ${
                                livestream.contents
                            }<br />
                    <span style="color:#8B22F9">Date and Time</span>: ${moment(
                        data.timeStart
                    ).format("lll")}<br />
                    <br />
                </p>`;
                        }
                        SocialAPI.sendEmailNotification({
                            message: mail,
                            subject: "Scheduled Meeting from Ulalive",
                            to: ls,
                        });
                    });

                    livestream.guestInvited.map((ls) => {
                        let selectedUser = _.find(users, (y) => y._id === ls);
                        if (selectedUser) {
                            let mail = "";
                            if (selectedCategory.name === "Public Hall") {
                                mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                  Scheduled public hall has been set
                  </p>
                  <p style="line-height: 30px; text-align:center">
                      Hello <span style="color:#8B22F9">${
                          selectedUser.fullName
                      }</span>,<br />
                      <span style="color:#8B22F9">${
                          livestream.owner.fullName
                      }</span> has scheduled a public hall.<br/>
                      Here are the public hall details
                  </p>
                  <p style="text-align:center;background:#F1F1F1;">
                      <br />
                      <span style="color:#8B22F9">Public Hall</span>: ${
                          livestream.title
                      }<br />
                      <span style="color:#8B22F9">Description</span>: ${
                          livestream.contents
                      }<br />
                      <span style="color:#8B22F9">Date and Time</span>: ${moment(
                          data.timeStart
                      ).format("lll")}<br />
                      <br />
                  </p>`;
                            } else if (
                                selectedCategory.name === "Private Hall"
                            ) {
                                mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                  Scheduled private lounge has been set
                  </p>
                  <p style="line-height: 30px; text-align:center">
                      Hello <span style="color:#8B22F9">${
                          selectedUser.fullName
                      }</span>,<br />
                      <span style="color:#8B22F9">${
                          livestream.owner.fullName
                      }</span> has scheduled a private lounge.<br/>
                      Here are the private lounge details
                  </p>
                  <p style="text-align:center;background:#F1F1F1;">
                      <br />
                      <span style="color:#8B22F9">Private Lounge</span>: ${
                          livestream.title
                      }<br />
                      <span style="color:#8B22F9">Description</span>: ${
                          livestream.contents
                      }<br />
                      <span style="color:#8B22F9">Date and Time</span>: ${moment(
                          data.timeStart
                      ).format("lll")}<br />
                      <br />
                  </p>`;
                            } else if (
                                selectedCategory.name === "Meeting Room"
                            ) {
                                mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                  Scheduled meeting has been set
                  </p>
                  <p style="line-height: 30px; text-align:center">
                      Hello <span style="color:#8B22F9">${
                          selectedUser.fullName
                      }</span>,<br />
                      <span style="color:#8B22F9">${
                          livestream.owner.fullName
                      }</span> has scheduled a video meeting.<br/>
                      Here are the meeting room details
                  </p>
                  <p style="text-align:center;background:#F1F1F1;">
                      <br />
                      <span style="color:#8B22F9">Meeting Room</span>: ${
                          livestream.title
                      }<br />
                      <span style="color:#8B22F9">Description</span>: ${
                          livestream.contents
                      }<br />
                      <span style="color:#8B22F9">Date and Time</span>: ${moment(
                          data.timeStart
                      ).format("lll")}<br />
                      <br />
                  </p>`;
                            } else if (selectedCategory.name === "VIP Circle") {
                                mail = `<p style="text-align: center; color:#000; font-size: 22px; font-weight: 600;">
                  Scheduled VIP circle has been set
                  </p>
                  <p style="line-height: 30px; text-align:center">
                      Hello <span style="color:#8B22F9">${
                          selectedUser.fullName
                      }</span>,<br />
                      <span style="color:#8B22F9">${
                          livestream.owner.fullName
                      }</span> has scheduled a VIP Circle.<br/>
                      Here are the VIP Circle details
                  </p>
                  <p style="text-align:center;background:#F1F1F1;">
                      <br />
                      <span style="color:#8B22F9">VIP Circle</span>: ${
                          livestream.title
                      }<br />
                      <span style="color:#8B22F9">Description</span>: ${
                          livestream.contents
                      }<br />
                      <span style="color:#8B22F9">Date and Time</span>: ${moment(
                          data.timeStart
                      ).format("lll")}<br />
                      <br />
                  </p>`;
                            }

                            SocialAPI.sendEmailNotification({
                                message: mail,
                                subject: "Scheduled Meeting from Ulalive",
                                to: selectedUser.email,
                            });
                        }
                    });

                    SocialAPI.sendPushNotification({
                        userIds: [...livestream.guestInvited, ...VIPIds],
                        title: "Scheduled Meeting",
                        content: `<p className="notification-info">
                <span className="fullName">
                ${livestream.owner.fullName}</span> re-scheduled the livestream 
                <span className="livestream-title">${livestream.title}</span>
                to ${moment(data.timeStart).format("lll")}`,
                        type: "schedule",
                        data: {
                            livestream: {
                                id: livestream._id,
                                title: livestream.title,
                                ownerName: livestream.owner.fullName,
                                ownerAttachment: livestream.owner.attachments,
                                category: selectedCategory.name,
                                scheduleTime: moment(data.timeStart).format(
                                    "lll"
                                ),
                            },
                            content: "livestream meeting ",
                        },
                    });

                    Swal.fire({
                        title: "Livestream",
                        text: "Livestream scheduled successfully",
                        icon: "success",
                        showCancelButton: true,
                        cancelButtonColor: "#d33",
                        showConfirmButton: false,
                        cancelButtonText: "Close",
                        customClass: {
                            cancelButton: "order-1 right-gap",
                            confirmButton: "order-2",
                            denyButton: "order-3",
                        },
                    });
                })
                .then(() => {
                    hmsActions.leave();
                    sessionStorage.setItem("category", livestream.category);
                    document.location.href = "/" + userProfile.userName;
                });
        }
    };

    var timeZones = moment.tz.names();
    const shareUrl =
        process.env.REACT_APP_URL + "/video/" + livestream._id;
    return (
        <Grid container spacing={1} className="mini-text">
            <Grid item xs={12} sm={12}>
                <TextField
                    fullWidth
                    variant="outlined"
                    disabled
                    id="myInputPreview"
                    value={shareUrl}
                    label="Share invitation link"
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <FileCopy
                                    onClick={() =>
                                        copyToClipboard("myInputPreview")
                                    }
                                />
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <h4 className="text-bold">Schedule later</h4>
            </Grid>
            <Grid item xs={4} sm={4}>
                <InputLabel className="mb-1 text-sm">Day</InputLabel>
                <FormControl variant="outlined" fullWidth>
                    <Select
                        margin="dense"
                        fullWidth
                        value={values.day}
                        onChange={(e) =>
                            setValues({ ...values, day: e.target.value })
                        }
                    >
                        {[...Array(31).keys()].map((x) => {
                            return (
                                <MenuItem value={pad(x + 1, 2)}>
                                    {pad(x + 1, 2)}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={4} sm={4}>
                <InputLabel className="mb-1 text-sm">Month</InputLabel>
                <FormControl variant="outlined" fullWidth>
                    <Select
                        margin="dense"
                        fullWidth
                        value={values.month}
                        onChange={(e) =>
                            setValues({ ...values, month: e.target.value })
                        }
                    >
                        {[...Array(12).keys()].map((x) => {
                            return (
                                <MenuItem value={pad(x + 1, 2)}>
                                    {pad(x + 1, 2)}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={4} sm={4}>
                <InputLabel className="mb-1 text-sm">Year</InputLabel>
                <FormControl variant="outlined" fullWidth>
                    <Select
                        margin="dense"
                        fullWidth
                        value={values.year}
                        onChange={(e) =>
                            setValues({ ...values, year: e.target.value })
                        }
                    >
                        {[...Array(2).keys()].map((x) => {
                            return (
                                <MenuItem
                                    value={pad(
                                        parseInt(moment().format("YYYY")) +
                                            parseInt(x),
                                        2
                                    )}
                                >
                                    {pad(
                                        parseInt(moment().format("YYYY")) +
                                            parseInt(x),
                                        2
                                    )}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={4} sm={4}>
                <InputLabel className="center-label mt-3 text-sm">Set Time</InputLabel>
            </Grid>
            <Grid item xs={8} sm={8}>
                <Grid container spacing={1}>
                    <Grid item xs={4} sm={4}>
                        <FormControl variant="outlined" fullWidth>
                            <Select
                                margin="dense"
                                fullWidth
                                value={values.hour}
                                onChange={(e) =>
                                    setValues({
                                        ...values,
                                        hour: e.target.value,
                                    })
                                }
                            >
                                {[...Array(12).keys()].map((x) => {
                                    return (
                                        <MenuItem value={pad(x + 1, 2)}>
                                            {pad(x + 1, 2)}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sm={4}>
                        <FormControl variant="outlined" fullWidth>
                            <Select
                                margin="dense"
                                fullWidth
                                value={values.minute}
                                onChange={(e) =>
                                    setValues({
                                        ...values,
                                        minute: e.target.value,
                                    })
                                }
                            >
                                <MenuItem value={"00"}>00</MenuItem>
                                {[0, ...Array(59).keys()].map((x) => {
                                    return (
                                        <MenuItem value={pad(x + 1, 2)}>
                                            {pad(x + 1, 2)}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4} sm={4}>
                        <FormControl variant="outlined" fullWidth>
                            <Select
                                margin="dense"
                                fullWidth
                                value={values.meridian}
                                onChange={(e) =>
                                    setValues({
                                        ...values,
                                        meridian: e.target.value,
                                    })
                                }
                            >
                                <MenuItem value="am">AM</MenuItem>
                                <MenuItem value="pm">PM</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={4} sm={4}>
                <InputLabel className="center-label mt-3 text-sm">Time Zone</InputLabel>
            </Grid>
            <Grid item xs={8} sm={8}>
                <FormControl variant="outlined" fullWidth>
                    <Select
                        margin="dense"
                        fullWidth
                        value={values.timeZone}
                        onChange={(e) =>
                            setValues({ ...values, timeZone: e.target.value })
                        }
                    >
                        {timeZones.map((x) => {
                            return (
                                <MenuItem value={x}>
                                    {x} (UTC {moment().tz(x).format("Z")})
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => savePreviewStream(true)}
                >
                    Set
                </Button>
            </Grid>
        </Grid>
    );
};

export default Schedule;
